'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _wrapNativeSuper = require('@babel/runtime/helpers/wrapNativeSuper');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultLegacy(_wrapNativeSuper);

var ParamError = /*#__PURE__*/function (_Error) {
  _inheritsLoose__default["default"](ParamError, _Error);

  function ParamError(message) {
    var _this;

    _this = _Error.call(this, "`" + message + "` not specified in parameters!") || this;
    _this.name = 'ParamError';
    return _this;
  }

  return ParamError;
}( /*#__PURE__*/_wrapNativeSuper__default["default"](Error));

exports["default"] = ParamError;
